import { c as _c } from "react/compiler-runtime";
import { Box, Flex, HStack, Image, Text, VStack, Separator } from '@chakra-ui/react';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
type SocialProofMasterclassCardProps = {
  title: string;
  bgImage?: string;
  customerLogo?: string;
  customerLogoWidth?: string;
  aspectRatio?: string;
};
export const SocialProofMasterclassCard = props => {
  const $ = _c(16);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  getBreakpointValue([false, false, true, false, false]);
  const t0 = props.aspectRatio || "16/9";
  const t1 = `url(${props.bgImage})`;
  let t2;
  if ($[0] !== props.customerLogo || $[1] !== props.customerLogoWidth) {
    t2 = props.customerLogo && <Box width={props.customerLogoWidth || "64px"}><Image alt="customer logo" filter={{
        _light: "invert(1) saturate(0)",
        _dark: "invert(0) saturate(1)"
      }} maxWidth={props.customerLogoWidth || "64px"} objectFit="contain" src={`url(${props.customerLogo})`} /></Box>;
    $[0] = props.customerLogo;
    $[1] = props.customerLogoWidth;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = props.customerLogo ? "block" : "none";
  let t4;
  if ($[3] !== t3) {
    t4 = <Separator borderColor="red.fg" display={t3} opacity={0.5} />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== getBreakpointValue || $[6] !== props.title) {
    t5 = props.title && <VStack align="flex-start" gap={0}><Text color="red.fg/75" fontSize={getBreakpointValue(["sm", "md", "lg"])} fontWeight={600}>{props.title}</Text></VStack>;
    $[5] = getBreakpointValue;
    $[6] = props.title;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t4 || $[10] !== t5) {
    t6 = <HStack align="center" backdropFilter="blur(10px)" bgColor="colorPalette.bg/75" borderBottomRadius="2xl" gap={4} justify="center" padding={4} width="full">{t2}{t4}{t5}</HStack>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t0 || $[13] !== t1 || $[14] !== t6) {
    t7 = <Flex align="center" aspectRatio={t0} bgColor="blue.fg/20" bgImage={t1} bgPos="top center" bgRepeat="no-repeat" bgSize="cover" borderRadius="2xl" boxShadow="lg" direction="column" justify="end" padding={0} width="full">{t6}</Flex>;
    $[12] = t0;
    $[13] = t1;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};